import React, { JSX } from 'react';
import s from './Button.module.scss';

export type ButtonVariant = 'primary' | 'secondary' | 'light' | 'dark';

interface ButtonProps {
  variant?: ButtonVariant;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
  dataTestId?: string;
  disabled?: boolean;
  className?: string;
}
export default function Button({ 
    variant = 'primary', 
    onClick, 
    children, 
    dataTestId, 
    disabled = false, 
    className 
}: ButtonProps): JSX.Element {
  return (
    <button
      data-theme={variant}
      data-testid={dataTestId}
      type="button"
      onClick={onClick}
      className={[s.btn, className].filter(Boolean).join(' ')}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
